import { Suspense } from 'react';
import { useSearchParams } from 'react-router-dom';

import { tabCaiDatTheoQuyen } from '../../../lib/caiDatTabs.js';
import { useToi } from '../../../lib/auth.js';
import { DanhSachSkeleton, EmptyState, PageHeader, Tabs } from '../../../ui/index.js';

/**
 * Cài đặt (`/cai-dat`) — khung chứa các mục cấu hình của **mọi** module.
 *
 * Bước 2 có hai trang cấu hình rời nhau: "Cài đặt công ty" (module 10, trong
 * menu) và "Kết nối API" (module 03, đã rút khỏi menu và chỉ vào được bằng một
 * link). Nay cả hai là mục của trang này; thêm mục mới chỉ cần thêm một file
 * `modules/<id>/caiDatTabs.tsx`, không sửa trang này (xem `lib/caiDatTabs.ts`).
 *
 * Trang **không có nút hành động** ở đầu: nút của mỗi mục nằm trong thanh công
 * cụ của chính mục đó, vì chúng cần trạng thái bên trong mục.
 */
export function TrangCaiDat() {
  const toi = useToi();
  const [thamSo, datThamSo] = useSearchParams();

  const muc = tabCaiDatTheoQuyen(toi.data?.permissions);
  const tho = thamSo.get('tab') ?? '';
  const dangMo = muc.find((m) => m.id === tho) ?? muc[0] ?? null;

  const doiTab = (moi: string) => {
    const tiep = new URLSearchParams(thamSo);
    tiep.set('tab', moi);
    datThamSo(tiep);
  };

  if (!dangMo) {
    return (
      <>
        <PageHeader title="Cài đặt" />
        <EmptyState
          title="Không có mục cài đặt nào bạn xem được"
          description="Liên hệ quản trị viên nếu bạn cần sửa cấu hình công ty hoặc kết nối API."
        />
      </>
    );
  }

  const Than = dangMo.component;

  return (
    <>
      <PageHeader
        title="Cài đặt"
        {...(dangMo.phu === undefined ? {} : { phu: dangMo.phu })}
        {...(dangMo.giaiThich === undefined ? {} : { giaiThich: dangMo.giaiThich })}
      />

      {/* Một mục thì không bày tab: một tab đơn độc chỉ chiếm chỗ. */}
      {muc.length > 1 && (
        <div className="mb-4">
          <Tabs
            aria-label="Mục cài đặt"
            value={dangMo.id}
            onChange={doiTab}
            items={muc.map((m) => ({ id: m.id, label: m.label }))}
          />
        </div>
      )}

      <Suspense fallback={<DanhSachSkeleton />}>
        <Than />
      </Suspense>
    </>
  );
}
